/* Elegance Hair Extensions — landing interactions
   Parallax hero · off-canvas menu · scroll reveal · sticky header */

(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ── Sticky header shadow ── */
  var header = document.getElementById("header");
  if (header) {
    var onScrollHeader = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    window.addEventListener("scroll", onScrollHeader, { passive: true });
    onScrollHeader();
  }

  /* ── Search panel toggle ── */
  var searchBtn = document.getElementById("searchBtn");
  var searchPanel = document.getElementById("searchPanel");
  if (searchBtn && searchPanel) {
    searchBtn.addEventListener("click", function () {
      var open = !searchPanel.hidden;
      searchPanel.hidden = open;
      if (!open) searchPanel.querySelector("input").focus();
    });
  }

  /* ── Mobile off-canvas menu ── */
  var burger = document.getElementById("burgerBtn");
  var menu = document.getElementById("mobileMenu");
  var closeBtn = document.getElementById("closeMenuBtn");
  var overlay = document.getElementById("overlay");

  if (burger && menu && closeBtn && overlay) {
    var setMenu = function (open) {
      menu.classList.toggle("is-open", open);
      menu.setAttribute("aria-hidden", String(!open));
      burger.setAttribute("aria-expanded", String(open));
      overlay.hidden = !open;
      requestAnimationFrame(function () {
        overlay.classList.toggle("is-visible", open);
      });
      document.body.style.overflow = open ? "hidden" : "";
    };
    burger.addEventListener("click", function () { setMenu(true); });
    closeBtn.addEventListener("click", function () { setMenu(false); });
    overlay.addEventListener("click", function () { setMenu(false); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") setMenu(false);
    });
  }

  /* ── 3D parallax hero (scroll-linked layer depths) ── */
  var hero = document.getElementById("hero");
  var layers = hero ? hero.querySelectorAll(".hero__layer") : [];
  if (hero && layers.length && !reduceMotion) {
    var ticking = false;
    var updateParallax = function () {
      var rect = hero.getBoundingClientRect();
      // progress: 0 at top of page, grows as hero scrolls out
      var progress = Math.min(Math.max(-rect.top, 0), rect.height);
      layers.forEach(function (layer) {
        var depth = parseFloat(layer.dataset.depth || "0");
        layer.style.transform = "translate3d(0," + (progress * depth * 0.55) + "px,0)";
      });
      ticking = false;
    };
    window.addEventListener("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
    updateParallax();

    /* subtle pointer parallax on desktop for extra depth */
    if (window.matchMedia("(pointer: fine)").matches) {
      hero.addEventListener("mousemove", function (e) {
        var cx = (e.clientX / window.innerWidth - 0.5);
        var cy = (e.clientY / window.innerHeight - 0.5);
        layers.forEach(function (layer) {
          var depth = parseFloat(layer.dataset.depth || "0");
          layer.style.setProperty("--mx", cx * depth * 18 + "px");
          var scrollY = layer.style.transform.match(/,(.+?)px,0\)/);
          var y = scrollY ? parseFloat(scrollY[1]) : 0;
          layer.style.transform =
            "translate3d(" + (cx * depth * 18) + "px," + (y + cy * depth * 10) + "px,0)";
        });
      });
    }
  }

  /* ── Scroll-reveal animations ── */
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -6% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ── Newsletter forms: friendly stub (WordPress plugin will replace) ── */
  document.querySelectorAll("form[action='#']").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("button");
      var prev = btn.textContent;
      btn.textContent = "¡Gracias! ✓";
      btn.disabled = true;
      setTimeout(function () {
        btn.textContent = prev;
        btn.disabled = false;
        form.reset();
      }, 2600);
    });
  });
})();

/* ── V2 expansion: colour swatch selector + section parallax ── */
(function () {
  "use strict";

  /* Colour swatch selector — updates the WhatsApp CTA + visible tone label */
  document.querySelectorAll(".swatch").forEach(function (swatch) {
    swatch.addEventListener("click", function () {
      document.querySelectorAll(".swatch").forEach(function (s) { s.classList.remove("active"); });
      swatch.classList.add("active");
      var toneMsg = swatch.getAttribute("data-msg");
      var waBtn = document.getElementById("swatchWaBtn");
      if (waBtn && toneMsg) {
        waBtn.href = "https://wa.me/34615430785?text=Hola%2C%20he%20elegido%20el%20tono%20" + toneMsg + "%20y%20quisiera%20asesorarme%20sobre%20extensiones%20de%20pelo";
      }
      var label = document.getElementById("swatchToneLabel");
      if (label) {
        label.innerHTML = "Tono seleccionado: <strong>" + (swatch.getAttribute("data-tone") || "") + "</strong>";
      }
    });
  });

  /* Scroll-linked parallax for section media ([data-parallax="0.1"]) */
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Pause decorative autoplay videos for reduced-motion users */
  if (reduceMotion) {
    document.querySelectorAll(".gallery video").forEach(function (v) {
      v.removeAttribute("autoplay");
      v.pause();
    });
  }
  var pEls = document.querySelectorAll("[data-parallax]");
  if (pEls.length && !reduceMotion) {
    var ticking = false;
    var updateSectionParallax = function () {
      var vh = window.innerHeight;
      pEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var factor = parseFloat(el.dataset.parallax || "0.1");
        // -1 .. 1 as the element crosses the viewport
        var progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2);
        var img = el.querySelector("img");
        if (img) {
          img.style.transform = "translate3d(0," + (-progress * factor * 100) + "px,0) scale(" + (1 + factor) + ")";
        }
      });
      ticking = false;
    };
    window.addEventListener("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(updateSectionParallax);
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener("resize", updateSectionParallax);
    updateSectionParallax();
  }
})();
